import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-full-text',
  templateUrl: './full-text.component.html',
  styleUrls: ['./full-text.component.scss'],
})
export class FullTextComponent  implements OnInit {

  tinyMceKey = environment.tinyMceKey;
  @Input() fullText: string = '';

  @Output() inputChange = new EventEmitter<{
    fullText: string;
  }>();
  constructor() { }

  ngOnInit() {
    // const formattedActualite = JSON.parse(localStorage.getItem('formattedActualite') || '{}');
    // const block = formattedActualite.articleBlocks.find((block: any) => block.type == 0);
    // if (block) {
    //   this.fullText = block.content.fullText;
    //   this.onEditorChange();
    // }
  }

  onEditorChange() {
    this.inputChange.emit({
      fullText: this.fullText,
    });
  }
}
